import React from 'react';

import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { hasAnyAllowedRole, resolveOrgAccess, USER_ROLES } from 'packages/utils';

import styles from './styles.module.less';

const MenuOption = ({
  as = '',
  className = '',
  selected = false,
  allowedRoles = null,
  ...props
}) => {
  const Element = as || Link;
  const { id: orgId } = useSelector(({ organizations }) => organizations.organization);
  const claims = useSelector(({ user }) => user.access.data?.claims);
  const orgUserAccess = useSelector(({ user }) => user.orgUser?.data?.access);
  const userOrgAccess = resolveOrgAccess(claims, orgId, orgUserAccess);
  const userOrgDivisions = useSelector(({ divisions }) => divisions?.assigned?.data?.divisions);

  const hasAccess = hasAnyAllowedRole(allowedRoles, userOrgAccess, userOrgDivisions);

  return hasAccess ? (
    <Element
      {...props}
      className={classnames(styles.button, className, selected && styles.selected)}
    />
  ) : (
    <> </>
  );
};

MenuOption.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  selected: PropTypes.bool,
  allowedRoles: PropTypes.arrayOf(PropTypes.oneOf(Object.values(USER_ROLES))),
};

export default MenuOption;
